import React from 'react';
import { observer } from "mobx-react";
import LinkWithIconV1 from 'ReactApp/Components/LinkWithIconV1/LinkWithIconV1';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartProductCardUnmarkAsDeletedV1Props = {
    card: DomainNs.ProductCardInterface,
    classes?: string[],
    label?: string,
}

const CartProductCardUnmarkAsDeletedV1 = observer((props: CartProductCardUnmarkAsDeletedV1Props) => {

    const toogleHandler = (e: React.MouseEvent<HTMLElement>) => {
        showableCartInstance.markAsUndeletedCard(props.card);
    }

    return (
        <LinkWithIconV1 onClick={toogleHandler} {...{
            label: props.label,
            classes: [
                'product-card-v6__action-favorite',
                'link-with-icon-v1_text-color-type-main',
                'link-with-icon-v1_decoration-type-none',
                ...(props.classes || [])
            ],
            iconProps: {
                svgSpriteId: 'back',
                width: 18,
                height: 18,
                classes: [
                    'link-with-icon-v1__icon'
                ]
            }
        }} />
    );

})

export default CartProductCardUnmarkAsDeletedV1;